import Vue from 'vue'
import Router from 'vue-router'
import { resolve } from 'url';

Vue.use(Router)
export default new Router({
  mode:'history',
  routes: [
            //pc端口开始
        {
            path: '/PrintGxk',
            name: 'PrintGxk',
            component:resolve => require(['@/components/PrintGxk'], resolve),
               
        },
        {
            path: '/PrintGxk2024',
            name: 'PrintGxk2024',
            component:resolve => require(['@/components/PrintGxk2024'], resolve),
               
        },
        {
            path: '/Print2024',
            name: 'Print2024',
            component:resolve => require(['@/components/Print2024'], resolve),
               
        },
        {
            path: '/PrintCurrent',
            name: 'PrintCurrent',
            component:resolve => require(['@/components/PrintCurrent'], resolve),
               
        },
        { //忘记密码
            path: '/NewPwd',
            name: 'NewPwd',
            component:resolve => require(['@/view/admin/NewPwd'], resolve),
        },
        {
            path: '/user',
            name: 'user',
            component:resolve => require(['@/view/user/UserView'], resolve),
            redirect: {name:'UserMessage'},
            children: [
                //修改身份证信息
                {
                    path: 'uploadcard',
                    name: 'uploadcard',
                    component:resolve => require(['@/view/user/cognition/uploadcard'], resolve),
                },
            //学分认定
            // {
            //     path: 'antivirus',
            //     name: 'antivirus',
            //     component:resolve => require(['@/view/user/cognition/antivirus'], resolve),
                
            // },
            // {
            //     path: 'assistance',
            //     name: 'assistance',
            //     component:resolve => require(['@/view/user/cognition/assistance'], resolve),
                
            // },
            {
                path: 'education',
                name: 'education',
                component:resolve => require(['@/view/user/cognition/education'], resolve),
            },
            // {
            //     path: 'approved',
            //     name: 'approved',
            //     component:resolve => require(['@/view/user/cognition/approved'], resolve),
                
            // },
            {
                path: 'inspect',
                name: 'inspect',
                component:resolve => require(['@/view/user/cognition/inspect'], resolve),
                
            },
            {
                path: 'creditrecognition',
                name: 'creditrecognition',
                component:resolve => require(['@/view/user/cognition/creditrecognition'], resolve),
                
            },
            {
                path: 'creditList',
                name: 'creditList',
                component:resolve => require(['@/view/user/cognition/creditList'], resolve),
               
            },
                //学分认定 end
            {
                path: 'finish',
                name: 'finish',
                component:resolve => require(['@/view/user/finish'], resolve),
               
            },
            {
                path: 'creditOut',
                name: 'creditOut',
                component:resolve => require(['@/view/user/creditOut'], resolve),
               
            },
            {
                path: 'study',
                name: 'study',
                component:resolve => require(['@/view/user/study'], resolve),
               
            },
            {
                path: 'register',
                name: 'register',
                component:resolve => require(['@/view/user/register'], resolve),
               
            },
            {
                path: 'enroll2022',
                name: 'enroll2022',
                component:resolve => require(['@/view/user/enroll'], resolve),
               
            },
            {
                path: 'message',
                name: 'message',
                component:resolve => require(['@/view/user/message'], resolve),
              
            },
            {
                path: 'reset',
                name: 'reset',
                component:resolve => require(['@/view/user/reset'], resolve),
              
            },
            {
                path: 'credit',
                name: 'credit',
                component:resolve => require(['@/view/user/credit'], resolve),
               
            },
            {
                path: 'picture',
                name: 'picture',
                component:resolve => require(['@/view/user/cognition/picture'], resolve),
               
            },
            {
                path: 'period',
                name: 'period',
                component:resolve => require(['@/view/user/period'], resolve),
               
            },
            {
                path: 'invoice',
                name: 'invoice',
                component:resolve => require(['@/view/user/invoice'], resolve),
               
            },
            {
                path: 'invoicelist',
                name: 'invoicelist',
                component:resolve => require(['@/view/user/invoicelist'], resolve),
               
            },
            // {
            //     path: 'print',
            //     name: 'print',
            //     component:resolve => require(['@/view/user/print'], resolve),
               
            // },
            // {
            //     path: 'printc',
            //     name: 'printc',
            //     component:resolve => require(['@/view/user/printc'], resolve),
               
            // },
            { 
                path: 'years',
                name: 'years',
                component:resolve => require(['@/view/user/years'], resolve),
              
            },
            { 
                path: 'membertext',
                name: 'membertext',
                component:resolve => require(['@/view/user/membertext'], resolve),
              
            },
            { 
                path: 'member',
                name: 'member',
                component:resolve => require(['@/view/user/member'], resolve),
              
            },
            { 
                path: 'payment',
                name: 'payment',
                component:resolve => require(['@/view/user/payment'], resolve),
              
            },
            { 
                path: 'success',
                name: 'success',
                component:resolve => require(['@/view/user/success'], resolve),
              
            },
            ]
        },
        {
            path:'/',
            redirect:{name:'login2022'},
        },
        {
            path: '/login2022',
            name: 'login2022',
            component:resolve => require(['@/view/content/login'], resolve),
           
        },
        {
            path: '/',
            name: 'Content',
            component:resolve => require(['@/view/content/Content'], resolve),
            redirect: {name:'index'},
            children: [
            {
                path: 'index',
                name: 'index',
                component:resolve => require(['@/view/content/index'], resolve),
               
            },
            ]
        },
   //pc端口结束
     //手机端接口开始
     {
        path: '/',
        name: 'ContentMobile',
        component:resolve => require(['@/ContentMobile'], resolve),
        redirect: {name:'IndexM'},
        children: [
        {// 用户中心
            path: 'UserCenter',
            name: 'UserCenter',
            component:resolve => require(['@/view/admin/UserCenter'], resolve),
           
        },
        {
            path: 'RegisterView',
            name: 'RegisterView',
            component:resolve => require(['@/view/admin/RegisterView'], resolve),
          
        },
        { // 查看公需课学分
            path: 'GXKCheckCredit',
            name: 'GXKCheckCredit',
           
            component:resolve => require(['@/view/admin/GXKCheckCredit'], resolve),
           
        },
        { // 查看学分
            path: 'CheckCredit',
            name: 'CheckCredit',
            component:resolve => require(['@/view/admin/CheckCredit'], resolve),
        },
        { // admin 个人信息
            path: 'InformationView',
            name: 'InformationView',
            component:resolve => require(['@/view/admin/InformationView'], resolve),
        },
        { // admin 修改身份证号
            path: 'MobileUploadCard',
            name: 'MobileUploadCard',
            component:resolve => require(['@/view/admin/MobileUploadCard'], resolve),
        },
        { // admin 修改身份证号列表
            path: 'ResetCardList',
            name: 'ResetCardList',
            component:resolve => require(['@/view/admin/ResetCardList'], resolve),
        },
        { // 课程列表
            path: 'ResetPwd',
            name: 'ResetPwd',
            component:resolve => require(['@/view/admin/ResetPwd'], resolve),
        },
        { // 学分查询
            path: 'CreditView',
            name: 'CreditView',
            component:resolve => require(['@/view/admin/CreditView'], resolve),
           
        },
        { // 学时折算
            path: 'PeriodView',
            name: 'PeriodView',
            component:resolve => require(['@/view/admin/PeriodView'], resolve),
           
        },
        { // 继续教育报名
            path: 'EnrollView',
            name: 'EnrollView',
            component:resolve => require(['@/view/admin/EnrollView'], resolve),
           
        },
        { // 继续教育会员收据
            path: 'EnrollInvoice',
            name: 'EnrollInvoice',
            component:resolve => require(['@/view/admin/EnrollInvoice'], resolve),
           
        },
        { // 继续教育报名是否入会
            path: 'EnrollMemberText',
            name: 'EnrollMemberText',
            component:resolve => require(['@/view/admin/EnrollMemberText'], resolve),
           
        },
        { // 继续教育报名是否入会
            path: 'EnrollMember',
            name: 'EnrollMember',
            component:resolve => require(['@/view/admin/EnrollMember'], resolve),
           
        },
        { // 继续教育学习选择年份
            path: 'StudyYears',
            name: 'StudyYears',
            component:resolve => require(['@/view/admin/StudyYears'], resolve),
           
        },
        { // 继续教育报名选择年份
            path: 'EnrollYears',
            name: 'EnrollYears',
            component:resolve => require(['@/view/admin/EnrollYears'], resolve),
           
        },
         {// 上传补休证明
            path: 'EnrollUpload',
            name: 'EnrollUpload',
            component:resolve => require(['@/view/admin/EnrollUpload'], resolve),
           
        },
        { // 继续教育报名支付
            path: 'EnrollPayment',
            name: 'EnrollPayment',
            component:resolve => require(['@/view/admin/EnrollPayment'], resolve),
           
        },
        { // 手机支付成功
            path: 'MobileFInish',
            name: 'MobileFInish',
            component:resolve => require(['@/view/admin/MobileFInish'], resolve),
           
        },
        { // 发票
            path: 'InvoiceView',
            name: 'InvoiceView',
            component:resolve => require(['@/view/admin/InvoiceView'], resolve),
           
        },
        ]
    }
  ]
})
// export 



// WEBPACK FOOTER //
// ./src/router/index.js